export default {
  filters: state => {
    return state.filters;
  },
  timeFrames: state => {
    return state.timeFrames;
  },
  selectedTimeFrameId: state => {
    return state.filters.timeFrameId;
  },
  selectedTimeFrame: state => {
    const filtered = state.timeFrames.filter(item => {
      return parseInt(item.id) === parseInt(state.filters.timeFrameId);
    });

    return filtered.length > 0 ? filtered[0] : null;
  },
  events: state => {
    return state.events;
  },
  commandLog: state => {
    return state.commandLog;
  }
};